import React from 'react';

import { Pressable } from '@rbilabs/universal-components';
import { StyleSheet } from 'react-native';

import { Box, BoxProps } from 'components/ui';

export const CloseButtonWrapper = ({ style, ...props }: BoxProps) => (
  <Box {...props} style={[styles.closeButtonWrapper, style]} />
);

export const PressableButton = Pressable.withConfig({
  flex: 1,
  width: { base: '$14', md: '$20' },
  justifyContent: 'center',
  alignItems: 'center',
  hitSlop: 10,
});

const styles = StyleSheet.create({
  closeButtonWrapper: {
    bottom: 0,
    position: 'absolute',
    right: 0,
    top: 0,
  },
});
